import { render } from "./CompactMenuItem.vue?vue&type=template&id=036c1e1c&scoped=true"
import script from "./CompactMenuItem.vue?vue&type=script&lang=js"
export * from "./CompactMenuItem.vue?vue&type=script&lang=js"

import "./CompactMenuItem.vue?vue&type=style&index=0&id=036c1e1c&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036c1e1c"]])

export default __exports__